import { lazy } from 'react';

export const ListApplicationPageLazy = lazy(
  () => import('./ListApplicationsPage')
);
